import React, { useEffect } from "react";
import { Script } from "components/ExtendedContent/ExtendedContentContainer/layout";
import { scriptLoader } from "util/scriptLoader";
import { useStore, StoreTypes } from "context";
import { parseChineseOnly } from "util/zhuyin";

const StaticHtmlComponent = ({ html, extendedResourceStyle }) => {
  const [{ bookId, books }] = useStore(StoreTypes.books);
  const book = books.find((info) => info.bookId === bookId);
  const highGradeCheck = book.display_name.includes("國中國文"); //新增國中國文行距要縮小的需求

  useEffect(() => {
    if (html) {
      scriptLoader(Script[extendedResourceStyle]);
    }
  }, [extendedResourceStyle, html]);
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: highGradeCheck ? parseChineseOnly(html, "pirls") : html,
      }}
    />
  );
};

export default StaticHtmlComponent;
